<template>
  <div>
    <div>
      <p class="title">ДОВЕРЕННОСТЬ №{{ doc_id }}</p>
      <div style="display: flex; justify-content: space-between">
        <div>Город {{ doc.ktg_place }}</div>
        <div>&laquo;{{ day }}&raquo; {{ month }} {{ year }} г.</div>
      </div>

      <p style="text-align: justify">
        Владелец контракта {{ doc.ktg_principal_name }}, именуемое в дальнейшем
        «Доверитель», государственный регистрационный номер
        {{ doc.ktg_principal_reg_number }}, БИН {{ doc.ktg_principal_code }}, с
        местом нахождения по адресу: _юр. {{ doc.ktg_principal_address }}, в
        лице {{ doc.ktg_representative_job_title }}, действующего на основании
        {{ doc.ktg_acting_basis }}, уполномочивает:
      </p>
      <p>
        ТОО «ATTIS Eurasia», в лице Директора Токтабаянова Ержана Галимовича,
        действующего на основании Устава, представлять интересы Доверителя в АО
        «НК «КТЖ», АО «КТЖ-Грузовые перевозки», ОАО «РЖД» и их дочерних
        структурах, а также любых других организациях, связанных с эксплуатацией
        подвижного состава, для чего наделяется правом выполнять все необходимые
        действия по получению и обработке и дальнейшей передачи Доверителю
        информации о погрузке, выгрузке, дислокации, техническом состоянии и
        работе подвижного состава, находящегося в собственности или любом другом
        законном пользовании у Доверителя, используемого для осуществления
        перевозок грузов по железным дорогам Республики Казахстан, стран СНГ и
        Балтии.
      </p>
      <p style="text-align: justify">
        Настоящая Доверенность выдана для предъявления в администрации железных
        дорог, их дочерние структуры, а также любые другие организации,
        связанные с эксплуатацией и ремонтом подвижного состава, а также его
        учетом и начислением тарифов.
      </p>
      <p style="text-align: justify">Список вагонов-самосвалов:</p>

      <table class="table table-bordered" style="font-size: 11px">
        <tr>
          <th>№</th>
          <th>№ вагона</th>
        </tr>
        <tr v-for="(wagon, i) in doc.wagons" :key="i">
          <td>{{ wagon.ktg_wagon_id }}</td>
          <td>{{ wagon.ktg_wagon_number }}</td>
        </tr>
      </table>

      <p style="text-align: justify">
        Настоящая Доверенность выдана до &laquo;{{ dayIssued }}&raquo;
        {{ monthIssued }} {{ yearIssued }} г.
      </p>

      <div class="container">
        <div class="row">
          <div class="col-md-4">{{ doc.ktg_representative_job_title }}</div>
          <div class="col-md-4"></div>
          <div class="col-md-4">{{ doc.ktg_representative_full_name }}</div>
        </div>
      </div>
    </div>
    <canvas id="signature_canvas"></canvas>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/ru";
var QRCode = require("qrcode");
export default {
  name: "transport_contract",
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      ktg_attorney: {
        ktg_id: "",
        ref_doc_id: "",
        ktg_doc_date: "",
        ktg_place: "",
        ktg_principal_code: "",
        ktg_representative_job_title: "",
        ktg_acting_basis: "",
        ktg_attorney_issued_before: "",
        ktg_representative_full_name: "",
        ktg_principal_name: "",
        ktg_principal_reg_number: "",
        ktg_principal_address: "",
        wagons: [],
      },
    };
  },
  mounted() {
    // moment.locale(this.i18n.locale=='cn'?'zh-cn':'ru', this.i18n.locale=='cn'?zh:ru);
    moment.locale("ru");
    //this.$root.$emit('print-pdf', {signature: '', type: 'transport_contract'})
    axios
      .get(window.base + "/Document/LoadKtgAttorney/?doc_id=" + this.doc_id)
      .then((response) => {
        this.ktg_attorney = response.data;
        this.ktg_attorney.wagons.forEach((obj, index) => {
          obj.ktg_wagon_id = index + 1;
        });
        this.doc = this.ktg_attorney;
        axios
          .get(window.base + "/document/LoadSignature?doc_id=" + this.doc_id)
          .then((response) => {
            if (typeof response.data.signature !== "undefined") {
              // console.log("as")
              if (response.data.signature == "") {
                this.$root.$emit("print-pdf", {
                  signature: "",
                  type: "ktg_attorney",
                });
                new Noty({
                  theme: "light",
                  type: "error",
                  text: this.$t("message.contracts.no-signature-message"),
                  timeout: 5000,
                }).show();
              } else {
                var canvas = QRCode.toCanvas(response.data.signature, {
                  width: 100,
                  height: 100,
                });
                canvas.then((r) => {
                  // this.check_signature(value, ()=>{
                  this.$root.$emit("print-pdf", {
                    signature: r,
                    type: "ktg_attorney",
                  });
                  new Noty({
                    theme: "light",
                    type: "success",
                    text: this.$t("message.contracts.yes-signature-message"),
                    timeout: 5000,
                  }).show();
                  // window.webSocket.removeEventListener('message', {})
                  // })
                });
              }
            } else {
              // console.log("bs")
              this.$root.$emit("print-pdf", {
                signature: "",
                type: "ktg_attorney",
              });
              new Noty({
                theme: "light",
                type: "error",
                text: this.$t("message.contracts.no-signature-message"),
                timeout: 5000,
              }).show();
            }
          });
      });
  },
  methods: {
    /**
     * Checks if newly generated signature is similar to the one previously saved on the server.
     * If got true – everything ok, can download file, if false – then the document
     * has not been signed yet or has been changed after signing.
     */
    check_signature(signature, callback) {
      var fd = new FormData();
      fd.append("contract_id", this.doc_id);
      fd.append("signature", signature);
      axios.post(window.base + "/document/CheckSignature", fd).then((r) => {
        if (r.data == "False") {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.document_signature_is_wrong"),
            timeout: 5000,
          }).show();
        } else {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.document_signature_is_ok"),
            timeout: 5000,
          }).show();
          callback();
        }
      });
    },
    callback(r) {
      console.log(r);
      if (r.code == "200") {
        // console.log(r)
        var oParser = new DOMParser();
        var oDOM = oParser.parseFromString(
          r.getResponseObject(),
          "application/xml",
        );
        var value = oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
        var canvas = QRCode.toCanvas(value, { width: 100, height: 100 });
        canvas.then((r) => {
          this.check_signature(value, () => {
            this.$root.$emit("print-pdf", { signature: r, type: "invoice" });
            window.webSocket.close();
          });
        });
      }
    },
  },
  watch: {},
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    day() {
      return moment(this.doc.ktg_doc_date).format("D");
    },
    month() {
      return moment(this.doc.ktg_doc_date).format("MMMM");
    },
    year() {
      return moment(this.doc.ktg_doc_date).format("Y");
    },
    dayIssued() {
      return moment(this.doc.ktg_attorney_issued_before).format("D");
    },
    monthIssued() {
      return moment(this.doc.ktg_attorney_issued_before).format("MMMM");
    },
    yearIssued() {
      return moment(this.doc.ktg_attorney_issued_before).format("Y");
    },
    date() {
      return moment().format("D.MM.Y");
    },
  },
};
</script>
<style scoped>
.title:not(h1) {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
  font-size: 1.2em;
}
.subline {
  display: flex;
  justify-content: space-between;
  margin: 30px 0;
}
.subtitle {
  text-align: center;
  font-weight: bold;
}
</style>
